import { useEffect, useState } from 'react'

import useAsyncEffect from '@hooks/useAsyncEffect'
import { useClientSecret } from '@hooks/useCustomerPayment'
import Price, { Currency } from '@models/commerce/Price'
import http from '@utils/http'

import type { TaxApiParams } from './usePurchaseTitleDialog'
import type Product from '@models/Product'

interface Props {
  product: Product
  quantity: number
  taxApiParams?: TaxApiParams
}

const usePurchasePrice = ({ product, quantity, taxApiParams }: Props) => {
  const [tax, setTax] = useState(0) // float value in dollars
  const [price, setPrice] = useState(
    new Price({
      priceInCents: (product?.price ?? 0) * quantity,
      taxInCents: tax * 100,
      currency: product?.currency ?? Currency.USD,
    })
  )
  const clientSecret = useClientSecret(price)

  useAsyncEffect(
    async (isActive) => {
      // PaymentForm sets tax api route and parameters depending
      // on pre-saved credit card or new credit card input
      if (taxApiParams) {
        const [resp] = await http.post(taxApiParams.route, taxApiParams.params)
        if (isActive() && resp?.data.tax) setTax(parseFloat(resp.data.tax))
      }
    },
    [price, taxApiParams]
  )

  useEffect(() => {
    if (!product) return
    setPrice(
      new Price({
        priceInCents: (product.price ?? 0) * quantity,
        taxInCents: tax * 100,
        currency: product.currency ?? Currency.USD,
      })
    )
  }, [product, quantity, tax])

  return {
    price,
    clientSecret,
  }
}
export default usePurchasePrice
